<template>
  <ElDialog
    :visible="value"
    :title="$t('ADVERTISEMENT.NEGATIVE_KEYWORDS.ADD_TITLE')"
    width="25%"
    @close="closeAndReset"
  >
    <div>
      <ElForm
        ref="negativeKeywordModel"
        :model="negativeKeywordModel"
        :rules="negativeKeywordsRules"
        label-position="right"
        @submit.native.prevent="addNegativeKeyword"
      >
        <ElFormItem
          prop="query"
          :label="$t('ADVERTISEMENT.NEGATIVE_KEYWORDS.KEYWORD')"
        >
          <ElInput v-model="negativeKeywordModel.query" name="query" required />
        </ElFormItem>
        <ElFormItem
          prop="matchingType"
          :label="$t('ADVERTISEMENT.BID.MATCH_TYPE')"
        >
          <AlternativeSelect
            v-model="negativeKeywordModel.matchingType"
            :key-prop="matchType => matchType.property"
            :placeholder="$t('ADVERTISEMENT.BID.MATCH_TYPE')"
            :items="negativeMatchTypes"
            :label-prop="matchType => matchType.label"
            :value-prop="matchType => matchType.property"
          />
        </ElFormItem>
      </ElForm>
      <div slot="footer" class="dialog-footer">
        <ElButton
          type="primary"
          native-type="submit"
          size="large"
          :loading="isLoading"
          @click.native="addNegativeKeyword"
        >
          {{ $t('ADVERTISEMENT.NEGATIVE_KEYWORDS.ADD_BUTTON') }}
        </ElButton>
      </div>
    </div>
  </ElDialog>
</template>

<script>
import form from '@/mixins/form';
import campaignId from '@/mixins/advertisement/campaignId';
import NegativeKeyword from '@/api/negative-keyword';
import { negativeMatchTypes } from '../../common/constants';
import AlternativeSelect from '@@/common/AlternativeSelect';

export default {
  name: 'AddNegativeKeywordModal',
  components: { AlternativeSelect },

  mixins: [form, campaignId],

  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    const initialMatchType = negativeMatchTypes[0].property;
    return {
      negativeKeywordModel: {
        query: '',
        matchingType: initialMatchType,
      },

      isLoading: false,
    };
  },

  computed: {
    negativeMatchTypes() {
      return negativeMatchTypes;
    },
    negativeKeywordsRules() {
      const rules = {
        required: true,
        message: this.$t('VALIDATION_REQUIRED_ERR'),
        trigger: 'change',
      };

      return {
        query: {
          ...rules,
          type: 'string',
        },
      };
    },
  },

  methods: {
    closeAndReset() {
      this.resetForm('negativeKeywordModel');
      this.$emit('input', false);
    },

    addNegativeKeyword() {
      if (!this.isValid('negativeKeywordModel')) {
        return false;
      }

      this.isLoading = true;

      return NegativeKeyword.addNegativeKeyword({
        campaignId: this.campaignId,
        keyword: this.negativeKeywordModel.query,
        matchingType: this.negativeKeywordModel.matchingType,
      })
        .then(({ message, data }) => {
          this.$message.success(message);

          this.$emit('add', data);

          this.closeAndReset();
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
